<template>
  <div class="row">
    <div class="col">
      <div class="logo-container">
        <router-link to="/"><Logo class="logo"/></router-link>
      </div>
      <div class="content">
        <ul class="insights-list">
          <li class="insight-item">
            <a class="insight-link" href="#">Thought captures from Japan</a>
            <div class="insight-byline">MEDIUM ––– FEB 25, 2019</div>
          </li>
          <li class="insight-item">
            <a class="insight-link" href="#"
              >A Chef’s Mexican Fantasia at Empellón in Midtown</a
            >
            <div class="insight-byline">NYTIMES ––– FEB 15, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#"
              >Peloton's Raises $550M at a valuation of $4 billion</a
            >
            <div class="insight-byline">TECHCRUNCH ––– JAN 25, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#"
              >GoldieBlox Chapter books arrive!! "Only 53% of Children's Books
              Had Female Characters Who Spoke..."</a
            >
            <div class="insight-byline">LINKEDIN ––– JAN 6, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#">Thought captures from Japan</a>
            <div class="insight-byline">MEDIUM ––– FEB 25, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#"
              >A Chef’s Mexican Fantasia at Empellón in Midtown</a
            >
            <div class="insight-byline">NYTIMES ––– FEB 15, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#"
              >WSJ features Peloton's latest round of financing, which values
              the company at $1.25 billion</a
            >
            <div class="insight-byline">TWITTER ––– JAN 25, 2019</div>
          </li>

          <li class="insight-item">
            <a class="insight-link" href="#"
              >GoldieBlox Chapter books arrive!! "Only 53% of Children's Books
              Had Female Characters Who Spoke..."</a
            >
            <div class="insight-byline">LINKEDIN ––– JAN 6, 2019</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./Logo.vue";
export default {
  name: "Insights",
  components: {
    Logo
  },
  data() {
    return {
      msg: ""
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_variables.scss";
.insights-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.insight-item {
  margin-bottom: 2em;
}
.insight-link,
.insight-link:visited {
  color: $color-primary;
  text-decoration: none;
}
.insight-link:hover {
  text-decoration: underline;
}
.insight-byline {
  color: $color-blue;
  font-family: $font-national;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Insight.vue